import React, { useState, useEffect } from "react";
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { Base64 } from 'js-base64';
import { v4 as uuidv4 } from 'uuid';
import './IDProofing.css';
import { Button, Alert } from 'react-bootstrap';
import { isMobile } from "react-device-detect";
import QRCode from 'react-qr-code';
import config from '../configuration/config.json';
import superappLogo from '../icons/1024x1024ia.png';
import walletLogo from '../icons/1024x1024ia-1.png';

Base64.extendUint8Array();

function IDProofing() {
    const title = 'goID ID Proofing Portal';
    const [isLoading, setIsLoading] = useState(false);
    const [value, setValue] = useState("");
    const [show, setShow] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();
    useEffect(() => {
        if (!isMobile) {
            setValue(config.idproofing.baseurl);
        }

        const ua = navigator.userAgent || navigator.vendor || window.opera;

        // Extract iOS version (e.g., 16.5, 17.2)
        const match = ua.match(/OS (\d+)_(\d+)_?(\d+)?/);
        const iosVersion = match ? parseFloat(`${match[1]}.${match[2]}`) : null;

        // Check if running on iOS
        const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;

        if (isIOS && iosVersion && iosVersion < 17) {
            setShow(false);
        } else {
            const isLockdownMode = (
                typeof WebAssembly !== "object" ||
                typeof OffscreenCanvas !== "function"
            );

            if (isLockdownMode) {
                setErrorMessage("iOS Lockdown Mode may limit certain features. Please disable it for full functionality");
                setShow(true);
            }
        }

        if (localStorage.getItem('AppMode') == null || localStorage.getItem('AppMode') == undefined
            || localStorage.getItem('AppMode') == ""
        ) {
            const appname = new URLSearchParams(window.location.search).get('appname') || "";
            localStorage.setItem('AppMode', appname);
            setSelectedValue(appname);
        }

    }, [])

    async function startVerify(cardType) {
        setIsLoading(true);
        localStorage.setItem('CardType', cardType);
        if (cardType == 4 || cardType == 5) {
            const v4Id = uuidv4();
            let transationId = v4Id;
            navigate('/idproofing/startidproofingchv/' + transationId);
        } else if (cardType != 2) {
            const v4Id = uuidv4();
            let transationId = v4Id;
            navigate('/idproofing/startidproofing/' + transationId);
        }
        else {
            navigate('/idproofing/scanimage');
        }
    }


    async function startVerifyChipdata(selectedValue) {
        setIsLoading(true);
        localStorage.setItem('AppMode', selectedValue);
        localStorage.setItem('CardType', '2');
        navigate('/idproofing/scanimage');
    }


    const [
        selectedValue,
        setSelectedValue,
    ] = useState("");

    localStorage.setItem('AppMode', selectedValue);
    
    const styles = {
        container: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        radioButton: {
            padding: "8px 8px",
            borderRadius: "8px",
            margin: "8px",
            border: "2px solid #007BFF",
            background: "#fff",
            alignItems: "center",
            justifyContent: "center",
            width: "100px",
            cursor: "pointer",
            transition:
                "background-color 0.3s, color 0.3s",
        },
        selected: {
            background: "#007BFF",
            color: "#fff",
            borderColor: "#007BFF",
        },
        list: {
            listStyleType: "none",
            padding: 0,
            textAlign: "center",
            display: "flex",
            gap: "1px",
            "justify-content": "center"
        },
    };

    const CustomRadioButton = ({
        label,
        selected,
        onSelect,
    }) => (
        <li>
            <button
                style={{
                    ...styles.radioButton,
                    ...(selected
                        ? styles.selected
                        : {}),
                }}
                onClick={onSelect}
            >
                {label}
            </button>
        </li>
    );


    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>


            <main className="mainbg">

                <div class="container-fluid  text-center">
                    <div class="row" text-center>
                        <div class="col bannerdisplay">

                            <div className="headerdiv">
                                <h1 className="headerdisplay">{title}</h1>
                            </div>

                        </div>
                    </div>

                    <div class="row">
                        <div class="col scancontentarea">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col">
                                        <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
                                            {isMobile === true ? (
                                                <div>
                                                    {(selectedValue == '') &&

                                                        <div>
                                                            <div class="box">
                                                                <h3>eKYC with mobile document</h3>
                                                                <div> <p className="lead mb-4">
                                                                </p>
                                                                    <span>Option to open the mobile app</span>
                                                                    <ul style={styles.list}>

                                                                        <CustomRadioButton
                                                                            label="Deeplink"
                                                                            selected={
                                                                                selectedValue ===
                                                                                "D"
                                                                            }
                                                                            onSelect={() =>
                                                                                setSelectedValue(
                                                                                    "D"
                                                                                )
                                                                            }
                                                                        />

                                                                        <CustomRadioButton
                                                                            label="Webshare"
                                                                            selected={
                                                                                selectedValue ===
                                                                                "W"
                                                                            }
                                                                            onSelect={() =>
                                                                                setSelectedValue(
                                                                                    "W"
                                                                                )
                                                                            }
                                                                        />

                                                                    </ul>
                                                                </div>

                                                            </div>
                                                            <div class="box">
                                                                <h3>eKYC with physical document</h3>
                                                                <p className="lead mb-4">
                                                                </p>


                                                                <div>Please select your App</div>
                                                                <p className="lead mb-4">
                                                                </p>
                                                                <div>

                                                                    <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
                                                                        <div style={{ gap: 12 }}>

                                                                            <button
                                                                                key="toppansuperapp"
                                                                                type="button"
                                                                                aria-label="Toppan SuperApp"
                                                                                title="Toppan SuperApp"
                                                                                onClick={(e) => { startVerifyChipdata('toppansuperapp'); }}
                                                                                style={{
                                                                                    display: "inline-flex",
                                                                                    alignItems: "center",
                                                                                    gap: 8,
                                                                                    padding: "8px 12px",
                                                                                    border: "1px solid #ddd",
                                                                                    borderRadius: 6,
                                                                                    background: "#fff",
                                                                                    cursor: "pointer",
                                                                                }}
                                                                            >
                                                                                <img
                                                                                    src={superappLogo}
                                                                                    alt=""                    // empty alt since label is visible
                                                                                    width={80}
                                                                                    height={80}
                                                                                    style={{ display: "block" }}
                                                                                />
                                                                                <span>TOPPAN SuperApp</span>
                                                                            </button>
                                                                        </div>
                                                                        <div style={{ gap: 12 }}>
                                                                            <button
                                                                                key="toppanwallet"
                                                                                type="button"
                                                                                aria-label="Toppan Wallet"
                                                                                title="Toppan Wallet"
                                                                                onClick={(e) => { startVerifyChipdata('toppanwalletapp'); }}
                                                                                style={{
                                                                                    display: "inline-flex",
                                                                                    alignItems: "center",
                                                                                    gap: 8,
                                                                                    padding: "8px 12px",
                                                                                    border: "1px solid #ddd",
                                                                                    borderRadius: 6,
                                                                                    background: "#fff",
                                                                                    cursor: "pointer",
                                                                                }}
                                                                            >
                                                                                <img
                                                                                    src={walletLogo}
                                                                                    alt=""                    // empty alt since label is visible
                                                                                    width={80}
                                                                                    height={80}
                                                                                    style={{ display: "block" }}
                                                                                />
                                                                                <span>TOPPAN Wallet &nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                                            </button>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>


                                                    }
                                                    {(selectedValue == 'D' || selectedValue == 'W' || selectedValue != '') &&
                                                        <div>
                                                            <div class="box">
                                                                <h3>Please select doc type</h3>

                                                                <div class="row g-3 m-3">
                                                                    <div class="col-6 col-sm-4">
                                                                        <Button className="btn btn-primary btn-lg px-3 gap-1"
                                                                            type="button"
                                                                            disabled={isLoading}
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                startVerify(1);
                                                                            }}
                                                                        >
                                                                            <span className="px-2">mDL</span>
                                                                        </Button>
                                                                    </div>
                                                                    <div class="col-6 col-sm-4">
                                                                        <Button className="btn btn-primary btn-lg px-3 gap-1"
                                                                            type="button"
                                                                            disabled={isLoading}
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                startVerify(3);
                                                                            }}
                                                                        >
                                                                            <span className="px-2">photoID</span>
                                                                        </Button>
                                                                    </div>
                                                                    <div class="col-6 col-sm-4">
                                                                        <Button className="btn btn-primary btn-lg px-3 gap-1"
                                                                            type="button"
                                                                            disabled={isLoading}
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                startVerify(6);
                                                                            }}
                                                                        >
                                                                            <span className="px-2">PID</span>
                                                                        </Button>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    }

                                                    {(selectedValue == 'D' || selectedValue == 'W' || selectedValue != '') &&
                                                        <div>
                                                            <button type="button" onClick={(e) => {
                                                                e.preventDefault();
                                                                setSelectedValue("")
                                                            }} class="btn btn-outline-primary">Back</button>
                                                        </div>
                                                    }
                                                </div>
                                            ) : (
                                                <div>
                                                    <p className="lead mb-4">
                                                        Scan below QR code from mobile device to access the ID Proofing portal.
                                                    </p>

                                                    <QRCode
                                                        size={256}
                                                        style={{ maxWidth: "100%", width: "100%" }}
                                                        value={value}
                                                        viewBox={`0 0 256 256`}
                                                    />
                                                </div>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>

            </main>
            <Alert show={show} variant="danger" onClose={() => setShow(false)} dismissible>
                <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                <p>
                    {errorMessage}.
                </p>
            </Alert>
        </>
    );
}

export default IDProofing;
